document.addEventListener('DOMContentLoaded', () => {
  const components = document.querySelectorAll('.form-action__section');

  if (!components.length) {
    return;
  }

  components.forEach((component) => {
    const form = component.querySelector('.call-form');
    const thanks = component.querySelector('.form-action__thanks-container');
    const formContainer = component.querySelector('[data-form-container]');
    const replacement = component.querySelector('[data-form-replacement]');
    const actionAfterCall =
      (thanks && thanks.dataset && thanks.dataset.actionAfterCall) || 'button';
    const shouldReplaceForm =
      actionAfterCall === 'replace' && !!formContainer && !!replacement;
    const completeBtn = component.querySelector('.js-action-form-complete');

    if (!form || !thanks) {
      return;
    }

    thanks.style.display = 'none';

    form.addEventListener('submit', (e) => {
      e.preventDefault();

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const formData = new FormData(form);

      fetch(form.action, {
        method: form.method || 'POST',
        body: formData,
        mode: 'no-cors'
      })
        .then(() => {
          thanks.style.display = 'flex';
        })
        .catch((err) => {
          console.error('Error submitting call form:', err);
        });
    });

    if (completeBtn) {
      completeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        form.reset();
        thanks.style.display = 'none';
        formContainer.setAttribute('hidden', '');
        replacement.removeAttribute('hidden');
      });
    }
  });
});
